import { render } from "./BaseLayout.vue?vue&type=template&id=9a586ece"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"

import "./BaseLayout.vue?vue&type=style&index=0&id=9a586ece&lang=scss"

import exportComponent from "/Users/molinam/gitlab/techbio2025-vue-app/vue-mobile-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__